module.exports = __webpack_public_path__ + "assets/jquery.c1f30013.svg";